import {createReducer} from '@reduxjs/toolkit'
import {PROMPT_LOGIN_OLD, memberLoggedIn as memberLoggedInAction} from '../actions/members'

export const memberLoggedIn = createReducer(false, builder =>
  builder
    .addCase(memberLoggedInAction, () => true)
    .addMatcher(
      action => action.type === PROMPT_LOGIN_OLD.SUCCESS,
      (_, action) => action.payload,
    ),
)
